import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Card, Form, Input, message, Popconfirm } from 'antd';
import api from '../../api';
import LoadingSpinner from '../../components/loading-spinner/loading-spinner';
import FaIcon from '../../components/global/fa-icon/fa-icon';



class UserEditView extends Component {

  constructor(props) {
    super(props);

    let id = _.get(this, 'props.match.params.id', null);

    this.state = {
      loaded: false,
      saving: false,
      id: id,
      data: null,
    };

    this.onUsernameChanged = this.onUsernameChanged.bind(this);
    this.onNameChanged = this.onNameChanged.bind(this);
    this.onEmailChanged = this.onEmailChanged.bind(this);
    this.onPhoneChanged = this.onPhoneChanged.bind(this);
    this.onAddressChanged = this.onAddressChanged.bind(this);
    this.onAddressCityChanged = this.onAddressCityChanged.bind(this);
    this.onAddressStateChanged = this.onAddressStateChanged.bind(this);
    this.onAddressZipChanged = this.onAddressZipChanged.bind(this);

    this.onSaveClicked = this.onSaveClicked.bind(this);
    this.onBackClicked = this.onBackClicked.bind(this);
    this.onCancelClicked = this.onCancelClicked.bind(this);
    this.onDeleteClicked = this.onDeleteClicked.bind(this);

    setTimeout(() => {
      this.invalidateData(false);
    }, 0);
  }

  async invalidateData(forceUpdate = false) {
    let id = this.state.id;

    if (forceUpdate || !this.state.loaded) {
      this.prevQuery = null;
    }
    if (this.prevQuery && _.isEqual(this.prevQuery, id)) {
      return false;
    }
    this.prevQuery = id;

    let item = null;
    if (id) {
      let res = await api.users.get(id);
      item = _.get(res, 'data') || null;
    }
    if (!item) {
      item = new api.models.UserModel();
    }

    this.setState({ loaded: true, data: item });
    return true;
  }

  isAddMode() {
    return !this.state.id;
  }

  _getTargetStringValue(e, trim = false) {
    let value = _.get(e, 'target.value');
    if (trim) {
      value = _.trim(value);
    }
    if (!value || _.isEmpty(value)) { value = null; }
    return value;
  }

  onUsernameChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.username = value;
    this.setState({ data });
  }

  onNameChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.name = value;
    this.setState({ data });
  }

  onAddressChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.address = value;
    this.setState({ data });
  }

  onAddressCityChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.address_city = value;
    this.setState({ data });
  }

  onAddressStateChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.address_state = value;
    this.setState({ data });
  }

  onAddressZipChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.address_zip = value;
    this.setState({ data });
  }

  onEmailChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.email = value;
    this.setState({ data });
  }

  onPhoneChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.phone = value;
    this.setState({ data });
  }

  onSaveClicked(e) {
    let modelData = this.state.data;
    this.setState({ loaded: false, saving: true }, () => {
      api.users.save(modelData.id, modelData).then(res => {
        let newId = _.get(res, 'data.id') || null;
        if (this.isAddMode() && newId) {
          this.props.history.push('/users/edit/' + newId);
        }
        this.setState({ id: newId, loaded: false, saving: false }, () => {
          this.invalidateData(true);
        });
      }).catch(err => {
        let msg = _.get(err, 'message') || 'An error has occurred';
        message.error(msg);
        this.setState({ loaded: true, saving: false });
      });
    });
  }

  onBackClicked(e) {
    this.props.history.push('/users');
  }

  onCancelClicked(e) {
    this.onBackClicked();
  }

  onDeleteClicked() {
    let id = _.get(this, 'state.data.id') || _.get(this, 'state.id') || null;
    this.setState({ loaded: false, saving: true }, () => {
      api.users.remove(id).then(res => {
        this.props.history.push('/users');
      });
    });
  }

  render() {

    let id = _.get(this, 'state.data.id') || _.get(this, 'state.id') || null;
    let canDelete = !!id;
    let title = id? ('Edit User ' + id): 'Add User';

    let titleActions = (
      <div className="title-actions">
        <Button type="default" size="large" icon={<FaIcon icon="fa-arrow-alt-left" />} onClick={this.onBackClicked}>Back</Button>
        <div className="title-text">{title}</div>
      </div>
    );

    let actions = (
      <div className="card-actions action-buttons">
        { canDelete? (
          <Popconfirm title="Are you sure you want to delete this user?"
                      okText="Yes"
                      cancelText="No"
                      onConfirm={this.onDeleteClicked}>
            <Button type="danger" size="large" icon={<FaIcon icon="fa-trash" />}>Delete</Button>
          </Popconfirm>
        ) : null }
        <div className="ml-3">&nbsp;</div>
        <Button type="default" size="large" icon={<FaIcon icon="fa-times" />} onClick={this.onCancelClicked}>Cancel</Button>
        <Button type="primary" size="large" icon={<FaIcon icon="fa-check" />} onClick={this.onSaveClicked}>Save</Button>
      </div>
    );


    return (
      <div className="user-edit-view mx-auto" >
        <Card title={titleActions} extra={actions}>
          <div className="page-content">
            { (!this.state.loaded)? <LoadingSpinner />: null }

            { (this.state.loaded)? this.renderEditArea(): null }

            { (false && this.state.loaded)? this.renderJsonData(): null }
          </div>
        </Card>
      </div>
    );
  }

  renderEditArea() {
    let data = this.state.data;

    return (
      <Form className="edit-user-content d-flex flex-row" layout="vertical">
        <div className="details-area container-fluid">

          <div className="row">
            <div className="col-sm-6 col-12">
              <Form.Item label="Username" colon={false}>
                <Input className="fillx" value={data.username} onChange={this.onUsernameChanged} />
              </Form.Item>
            </div>
            <div className="col-sm-6 col-12">
              <Form.Item label="Name" colon={false}>
                <Input className="fillx" value={data.name} onChange={this.onNameChanged} />
              </Form.Item>
            </div>
            <div className="col-sm-6 col-12">
              <Form.Item label="Email" colon={false}>
                <Input className="fillx" value={data.email} onChange={this.onEmailChanged} />
              </Form.Item>
            </div>
            <div className="col-sm-6 col-12">
              <Form.Item label="Phone" colon={false}>
                <Input className="fillx" value={data.phone} onChange={this.onPhoneChanged} />
              </Form.Item>
            </div>

            <div className="col-sm-6 col-12">
              <Form.Item label="Address Street" colon={false}>
                <Input className="fillx" value={data.address} onChange={this.onAddressChanged} />
              </Form.Item>
            </div>
            <div className="col-sm-6 col-12">
              <Form.Item label="City" colon={false}>
                <Input className="fillx" value={data.address_city} onChange={this.onAddressCityChanged} />
              </Form.Item>
            </div>
            <div className="col-sm-6 col-12">
              <Form.Item label="State" colon={false}>
                <Input className="fillx" value={data.address_state} onChange={this.onAddressStateChanged} />
              </Form.Item>
            </div>
            <div className="col-sm-6 col-12">
              <Form.Item label="Zip Code" colon={false}>
                <Input className="fillx" value={data.address_zip} onChange={this.onAddressZipChanged} />
              </Form.Item>
            </div>
          </div>

        </div>
      </Form>
    );
  }

  renderJsonData() {
    return (
      <pre>{ JSON.stringify(this.state.data, null, 2) }</pre>
    );
  }

}



function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}


const mapDispatchToProps = {
  // setAuthState,
  // getAuthSessionStateToken,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserEditView));

